import { useLocation, useNavigate } from 'react-router-dom';
import { fetchCoctail, getCoctailById } from '../../store/coctailsSlice';
import { useEffect } from 'react';
import { Descriptions, Image, Tag } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import styles from './CocktailViewPage.module.scss';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { Button, Layout } from '../../components';
import { API_URL } from '../../lib/api/index';
import { EDIT_COCKTAIL_PAGE } from '../../lib';

const CocktailViewPage = ({ logOut }: { logOut: () => void }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const idCoctail = queryParams.get('id');
  const { data: coctail, loading } = getCoctailById(useAppSelector(state => state.coctailsReducer));

  useEffect(() => {
    dispatch(fetchCoctail({ id: idCoctail }));
  }, [idCoctail]);

  const redirectToEditCoctail = async () => {
    navigate(`${EDIT_COCKTAIL_PAGE}?id=${idCoctail}`);
  };

  const items = [
    {
      key: '1',
      label: 'Images',
      span: 3,
      children: (
        <>
          {coctail?.eng?.media.posterName ? (
            <div className={styles.imageList}>
              <Image
                src={`${API_URL}/storage/image/${coctail?.eng?.media.posterName}`}
                style={{ maxHeight: '100%' }}
              />
            </div>
          ) : (
            <MinusOutlined rev={undefined} />
          )}
        </>
      ),
    },
    {
      key: 2,
      label: 'Video',
      span: 3,
      children: (
        <>
          {coctail?.eng?.media.videoName ? (
            <div className={styles.video}>
              <video width={'100%'} controls>
                <source
                  src={`${API_URL}/storage/content/${coctail?.eng?.media.videoName}`}
                  type="video/mp4"
                />
              </video>
            </div>
          ) : (
            <MinusOutlined rev={undefined} />
          )}
        </>
      ),
    },
    {
      key: 24,
      label: 'ID',
      span: 3,
      children: (
        <>
          <div>
            <Tag color="#000">{coctail?.indexName || '...'}</Tag>
          </div>
        </>
      ),
    },
    {
      key: 23,
      label: 'Access',
      span: 3,
      children: coctail?.eng?.access,
    },
    {
      key: 4,
      label: 'Created at',
      span: 3,
      children: coctail?.createdAt?.slice(0, 10),
    },
    {
      key: 5,
      label: 'Updated at',
      span: 3,
      children: coctail?.updatedAt?.slice(0, 10),
    },

    {
      key: 3,
      label: 'Description',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>{coctail?.eng?.description}</span>
          <span className={styles.item}>{coctail?.ru?.description}</span>
        </div>
      ),
    },
    {
      key: 6,
      label: 'Main ingredient',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.baseSpirit.map((spirit, idx) => (
              <div key={idx}>{spirit}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.baseSpirit.map((spirit, idx) => (
              <div key={idx}>{spirit}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 7,
      label: 'Ingredients',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.ingredients?.map((ingredient, idx) => (
              <div key={idx}>
                {ingredient.description}: {ingredient.value}
                {ingredient.unit}
              </div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.ingredients?.map((ingredient, idx) => (
              <div key={idx}>
                {ingredient.description}: {ingredient.value}
                {ingredient.unit}
              </div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 8,
      label: 'Tools',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.tools.map((tool, idx) => (
              <div key={idx}>{tool}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.tools.map((tool, idx) => (
              <div key={idx}>{tool}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 9,
      label: 'Additional tools',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.addTools.map((tool, idx) => (
              <div key={idx}>{tool}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.addTools.map((tool, idx) => (
              <div key={idx}>{tool}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 10,
      label: 'Category',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.category.map((cat, idx) => (
              <div key={idx}>{cat}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.category.map((cat, idx) => (
              <div key={idx}>{cat}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 11,
      label: 'Color',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.color}</span>
          <span className={styles.item}> {coctail?.ru?.color}</span>
        </div>
      ),
    },
    {
      key: 12,
      label: 'Country',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.country}</span>
          <span className={styles.item}> {coctail?.ru?.country}</span>
        </div>
      ),
    },
    {
      key: 13,
      label: 'Origin',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.origin}</span>
          <span className={styles.item}> {coctail?.ru?.origin}</span>
        </div>
      ),
    },
    {
      key: 13,
      label: 'Degrees',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.degrees}</span>
          <span className={styles.item}> {coctail?.ru?.degrees}</span>
        </div>
      ),
    },
    {
      key: 13,
      label: 'Difficulty',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.difficulty}</span>
          <span className={styles.item}> {coctail?.ru?.difficulty}</span>
        </div>
      ),
    },
    {
      key: 13,
      label: 'Group',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}> {coctail?.eng?.group}</span>
          <span className={styles.item}> {coctail?.ru?.group}</span>
        </div>
      ),
    },
    {
      key: 13,
      label: 'Flavor',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.flavor.map((fl, idx) => (
              <div key={idx}>{fl}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.flavor.map((fl, idx) => (
              <div key={idx}>{fl}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 14,
      label: 'Garnish',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.garnish.map((gar, idx) => (
              <div key={idx}>{gar}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.garnish.map((gar, idx) => (
              <div key={idx}>{gar}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 15,
      label: 'Glassware',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.glassware.map((gl, idx) => (
              <div key={idx}>{gl}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.glassware.map((gl, idx) => (
              <div key={idx}>{gl}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 16,
      label: 'Method making',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.methodMaking.map((method, idx) => (
              <div key={idx}>{method}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.methodMaking.map((method, idx) => (
              <div key={idx}>{method}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 17,
      label: 'Strength',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.strength.map((st, idx) => (
              <div key={idx}>{st}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.strength.map((st, idx) => (
              <div key={idx}>{st}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 18,
      label: 'Volume',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>{coctail?.eng?.volume}</span>
          <span className={styles.item}>{coctail?.ru?.volume}</span>
        </div>
      ),
    },
    {
      key: 19,
      label: 'Time for cocktail',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.timeForCocktail.map((time, idx) => (
              <div key={idx}>{time}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.timeForCocktail.map((time, idx) => (
              <div key={idx}>{time}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 20,
      label: 'Type of ice',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.typeIce.map((ice, idx) => (
              <div key={idx}>{ice}</div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.typeIce.map((ice, idx) => (
              <div key={idx}>{ice}</div>
            ))}
          </span>
        </div>
      ),
    },
    {
      key: 21,
      label: 'Type serving',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>{coctail?.eng?.typeServing}</span>
          <span className={styles.item}>{coctail?.ru?.typeServing}</span>
        </div>
      ),
    },
    {
      key: 22,
      label: 'Steps',
      span: 3,
      children: (
        <div className={styles.itemWrap}>
          <span className={styles.item}>
            {coctail?.eng?.cookingSteps.map((step, idx) => (
              <div key={idx}>
                {step?.time} sec.: {step?.description.map(i => i.value).join(' ')}.
              </div>
            ))}
          </span>
          <span className={styles.item}>
            {coctail?.ru?.cookingSteps.map((step, idx) => (
              <div key={idx}>
                {step?.time} сек.: {step?.description.map(i => i.value).join(' ')}.
              </div>
            ))}
          </span>
        </div>
      ),
    },
  ];

  return (
    <Layout
      logOut={logOut}
      loading={loading}
      title={
        <div className={styles.layoutTitle}>
          <div>{coctail?.eng?.name}</div>

          <Button label={'Edit cocktail'} bg="#000" color="#fff" onClick={redirectToEditCoctail} />
        </div>
      }
    >
      {!loading && (
        <Descriptions
          style={{ maxWidth: 1000 }}
          labelStyle={{ fontWeight: 700, fontSize: 14 }}
          size="small"
          bordered
          items={items}
        />
      )}
    </Layout>
  );
};

export default CocktailViewPage;
